import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 3.05493,13 C 3.49611,16.991 6.54685,20.1954 10.463,20.8693 9.06356,18.5666 8.19291,15.8821 8.02845,13 Z m 6.97717,0 C 10.186,15.3855 10.8862,17.6092 12,19.5399 13.1138,17.6092 13.814,15.3855 13.9679,13 Z M 12,4.46008 C 10.8862,6.39082 10.186,8.61451 10.0321,11 h 3.9358 C 13.814,8.61451 13.1138,6.39082 12,4.46008 Z M 15.9715,13 C 15.8071,15.8821 14.9364,18.5666 13.537,20.8693 17.4531,20.1954 20.5039,16.991 20.9451,13 Z M 13.537,3.13072 C 14.9364,5.4334 15.8071,8.11793 15.9715,11 h 4.9736 C 20.5039,7.00903 17.4531,3.80457 13.537,3.13072 Z M 23,12 C 23,18.0751 18.0751,23 12,23 5.92487,23 1,18.0751 1,12 1,5.92487 5.92487,1 12,1 18.0751,1 23,5.92487 23,12 Z M 8.02845,11 C 8.19291,8.11793 9.06355,5.4334 10.463,3.13072 6.54685,3.80457 3.49611,7.00903 3.05493,11 Z"
  }));
});
var DescriptiveInternet = AbstractIcon.withComponent(Icon);
DescriptiveInternet.displayName = 'DescriptiveInternet';
export default DescriptiveInternet;